// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"b522f61c","41":"b522f61c"}[chunkId] + ".chunk.css";
};